export enum PaymentSyncState {
    Failed = -2,
    Pending = -1,
    Succedded = 0,
}